import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  imports: [],
  template: `
    <p>
      forbidden works!
    </p>
  `,
  styleUrl: './forbidden.component.scss',
  host: {
    class: 'page h-full'
  },
})
export class ForbiddenComponent {

}
